import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import PlayButton from './ui/PlayButton';
import LoadingBar from './ui/LoadingBar';
import ListHeader from './ui/ListHeader';
import ListFilter from './filters/ListFilter';
import PaginationButtons from './PaginationButtons';
import NoResults from './ui/NoResults';
import SagnirMap from './SagnirMap';
import TabContainer from './ui/TabContainer';
import DataCounter from './ui/DataCounter';

import config from './../config';
import helpers from './../lib/helpers';
import _ from 'underscore';

const l = window.l;

function SagnirList(props) {
	const [data, setData] = useState(null);
	const [currentSearchTerm, setCurrentSearchTerm] = useState(null);
	const [nextUrl, setNextUrl] = useState(null);
	const [previousUrl, setPreviousUrl] = useState(null);
	const [resultCount, setResultCount] = useState(0);
	const [loading, setLoading] = useState(true);
	const [informantsMapView, setInformantsMapView] = useState(null);

	let history = useHistory();

	useEffect(() => {
		fetchData();
	}, [props.locationId, props.searchParams]);

	const fetchData = () => {
		setLoading(true);
		setData(null);
		setCurrentSearchTerm(null)

		let urlParams = [];

		/*
		let params;
		if (props.searchParams) {
			params = helpers.parseSearchParams(props.searchParams);
		}
		else {
			params = props;
		}
		*/

		let params = _.clone(props);

		if (props.searchParams) {
			let searchParams = helpers.parseSearchParams(props.searchParams);

			params = _.extend(params, searchParams);
		}

		if (params.texti) {
			urlParams.push('text='+params.texti)
		}

		if (props.locationId) { // staðsetning
			urlParams.push('location='+props.locationId)
		}

		if (params.form) {
			urlParams.push('type='+params.form)
		}

		if (params.einstaklingur) { // einstaklingur
			if (helpers.isNumber(params.einstaklingur)) {
				urlParams.push('person='+params.einstaklingur)
			}
			else {
				urlParams.push('person_name='+params.einstaklingur)
			}
		}

		if (params.heimildarmadur) { // heimildarmaður
			if (helpers.isNumber(params.heimildarmadur)) {
				urlParams.push('informant='+params.heimildarmadur)
			}
			else {
				urlParams.push('informant_name='+params.heimildarmadur)
			}
		}

		if (params.heimildarmadur_kyn) { // kyn heimildarmanns
			urlParams.push('informant_gender='+params.heimildarmadur_kyn)
		}

		if (params.heimildarmadur_stadsetning) { // uppruni heimildarmanns
			urlParams.push('informant_location='+params.heimildarmadur_stadsetning)
		}

		if (params.skrasetjari) { // skrásetjari
			if (helpers.isNumber(params.skrasetjari)) {
				urlParams.push('recorder='+params.skrasetjari)
			}
			else {
				urlParams.push('recorder_name='+params.skrasetjari)
			}
		}

		if (params.efnisord) { // efnisorð
			urlParams.push('keyword='+params.efnisord)
		}

		if (params.sagnagerd) { // sagnagerð
			urlParams.push('key_name='+params.sagnagerd)
		}

		if (params.sagnagerdId) { // sagnagerð
			urlParams.push('key='+params.sagnagerdId)
		}

		if (params.bok) { // bók / handrit
			urlParams.push('book='+params.bok)
		}

		if (params.flokkur) { // flokkur
			urlParams.push('category='+params.flokkur)
		}

		if (params.safn) { // safn
			urlParams.push('collection='+params.safn)
		}

		if (params.sogustadir) { // flokkur
			urlParams.push('location='+params.sogustadir)
		}

		if (params.tungumal) { // tungumál
			if (params.tungumal != 'oll') {
				urlParams.push('language='+params.tungumal)
			}
		}
		//else {
		//	urlParams.push('language=is');
		//}

		if (params.sida) {
			urlParams.push('limit='+config.pageSize);
			urlParams.push('offset='+(config.pageSize*(params.sida-1)))
		}

		setCurrentSearchTerm(params.texti)

		helpers.fetch(config.apiRoot+'/api/folklore/?'+urlParams.join('&'), (json) => {
			if (json) {
				setData(json.results);
				setNextUrl(json.next);
				setPreviousUrl(json.previous);
				setResultCount(json.count);

				if (props.onResponse) {
					props.onResponse(json.results);
				}
			}
			setLoading(false);
		});
	};

	let table = <React.Fragment>
		{
			data && data.length > 0 &&
			<React.Fragment>
				<table className="table">
					<thead>
						<tr>
							<th width="40%">{l('Titill')}</th><th>{l('Tegund')}</th><th>{l('Heimild')}</th>
						</tr>
					</thead>
					<tbody>
						{
							data.map((item, index) => <tr key={index}>
								<td>
									<Link to={helpers.routerUrls['sagnir_aevintyri']+item.id}>
										{item.name || '-'}
									</Link>
								</td>
								<td>{
									helpers.metadataList(item.type, helpers.routerUrls['tjodfraedi_leit'], 'id', 'name', 'form')
								}</td>
								<td>{item.source}</td>
							</tr>)
						}
					</tbody>
				</table>
				{
					resultCount > config.pageSize &&
					<PaginationButtons resultCount={resultCount}
						previousUrl={previousUrl}
						nextUrl={nextUrl} />
				}
			</React.Fragment>
		}
	</React.Fragment>

	let listFilters = [
		{
			label: l('Efni eða heiti'),
			paramName: 'texti',
			type: 'text'
		},
		{
			label: l('Efnisorð'),
			paramName: 'efnisord',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'keywords',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith'
			},
			viewAllLink: helpers.routerUrls['efnisord']
		},
		{
			label: l('Handrit/bók'),
			paramName: 'bok',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'book',
				labelField: 'number',
				valueField: 'id',
				filterParam: 'name_startswith'
			},
			options: {
				extraParams: ['folklore=true']
			},
			viewAllLink: helpers.routerUrls['baekur']
		},
		{
			label: l('Samsafn'),
			paramName: 'safn',
			type: 'select',
			selectOptions: {
				endpoint: 'collections',
				labelField: 'name',
				valueField: 'id'
			},
			options: {
				extraParams: ['type=5']
			}
		},
		/*
		{
			label: l('Tungumál'),
			paramName: 'tungumal',
			type: 'select',
			disableNull: true,
			selectOptions: {
				options: [
					{
						label: l('Öll'),
						value: 'oll'
					},
					{
						label: l('Íslenska'),
						value: 'is'
					},
					{
						label: l('Enska'),
						value: 'en'
					},
					{
						label: l('Færeyska'),
						value: 'fo'
					}
				]
			}
		},
		*/
		/*
		{
			label: l('Heimildarmaður'),
			paramName: 'heimildarmadur',
			type: 'text'
		},
		*/
		{
			label: l('Heimildarmaður'),
			paramName: 'heimildarmadur',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'persons',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith',
				listLabelFormatFunc: (item) => <div>
					{item.name}
					{
						(item.date_of_birth || item.date_of_death || item.aka) &&
						<React.Fragment>
							<br/>
							<small>{item.aka && <em>{item.aka} </em>}{helpers.formatDate(item.date_of_birth, true)+'–'+helpers.formatDate(item.date_of_death, true)}</small>
						</React.Fragment>
					}
				</div>,
				enableTextInput: true
			},
			options: {
				extraParams: ['folklore=true']
			},
			viewAllLink: helpers.routerUrls['tjodfraedi_einstaklingar']
		},
		{
			label: l('Uppruni/heimili heimildarmanns'),
			paramName: 'heimildarmadur_stadsetning',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'locations',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith',
				disableLargeList: true,
				listLabelFormatFunc: (item) => <div>
					{item.name}
					{
						(item.parent) &&
						<React.Fragment>
							<br/>
							<small>{helpers.createLocationParentString(item.parent)}</small>
						</React.Fragment>
					}
				</div>
			},
			viewAllLink: helpers.routerUrls['stadir']
		},
		{
			label: l('Kyn heimildarmanns'),
			paramName: 'heimildarmadur_kyn',
			type: 'select',
			selectOptions: {
				options: [
					{
						label: l('Karl'),
						value: 'Karl'
					},
					{
						label: l('Kona'),
						value: 'Kona'
					}
				]
			}
		},
		/*
		{
			label: l('Skrásetjari/sendandi'),
			paramName: 'skrasetjari',
			type: 'text'
		},
		*/
		{
			label: l('Skrásetjari/sendandi'),
			paramName: 'skrasetjari',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'persons',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith',
				listLabelFormatFunc: (item) => <div>
					{item.name}
					{
						(item.date_of_birth || item.date_of_death || item.aka) &&
						<React.Fragment>
							<br/>
							<small>{item.aka && <em>{item.aka} </em>}{helpers.formatDate(item.date_of_birth, true)+'–'+helpers.formatDate(item.date_of_death, true)}</small>
						</React.Fragment>
					}
				</div>,
				enableTextInput: true
			},
			options: {
				extraParams: ['folklore=true']
			},
			viewAllLink: helpers.routerUrls['tjodfraedi_einstaklingar']
		},
		/*
		{
			label: l('Tengdur einstaklingur'),
			paramName: 'einstaklingur',
			type: 'text'
		},
		*/
		{
			label: l('Tengdur einstaklingur'),
			paramName: 'einstaklingur',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'persons',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith',
				listLabelFormatFunc: (item) => <div>
					{item.name}
					{
						(item.date_of_birth || item.date_of_death) &&
						<React.Fragment>
							<br/>
							<small>{helpers.formatDate(item.date_of_birth, true)+'–'+helpers.formatDate(item.date_of_death, true)}</small>
						</React.Fragment>
					}
				</div>,
				enableTextInput: true
			},
			options: {
				extraParams: ['folklore=true']
			},
			viewAllLink: helpers.routerUrls['tjodfraedi_einstaklingar']
		},
		{
			label: l('Sagnagerð/minni'),
			paramName: 'sagnagerd',
			type: 'text'
		},
		/*
		{
			label: l('Sagnagerð/minni'),
			paramName: 'sagnagerd',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'keys',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith',
				listLabelFormatFunc: (item) => <div>
					{item.name}
					{
						item.text &&
						<React.Fragment>
							<br/>
							<small>{item.text}</small>
						</React.Fragment>
					}
				</div>
			},
			viewAllLink: helpers.routerUrls['sagnagerd']
		},
		*/
		{
			label: l('Sögustaðir'),
			paramName: 'sogustadir',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'locations',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith',
				disableLargeList: true,
				listLabelFormatFunc: (item) => <div>
					{item.name}
					{
						(item.parent) &&
						<React.Fragment>
							<br/>
							<small>{helpers.createLocationParentString(item.parent)}</small>
						</React.Fragment>
					}
				</div>
			},
			viewAllLink: helpers.routerUrls['stadir']
		}
	];

	const FORM_FAIRYTALE = 1000013;
	const FORM_LEGEND = 1000003;

	if (!props.form) {
		listFilters.push({
			label: l('Form'),
			paramName: 'form',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'form',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith'
			}
		});
	}

	if (!props.form || props.form != FORM_LEGEND) {
		listFilters.push({
			label: l('Flokkur'),
			paramName: 'flokkur',
			type: 'multiselect',
			selectOptions: {
				endpoint: 'folklorecategories',
				labelField: 'name',
				valueField: 'id',
				filterParam: 'name_startswith'
			}
		});
	}

	return (
		<React.Fragment>
			{
				props.enableFilter &&
				<ListFilter filters={listFilters}
				currentParams={props.searchParams}
				onFilter={(event) => {
					history.push(history.location.pathname+helpers.updateSearchParams(props.searchParams, event));
				}} />
			}
			<div className={'position-relative '+(props.className || '')+(loading ? ' loading' : '')}>
				<LoadingBar />
				{
					data && data.length > 0 &&
					<React.Fragment>
						{
							props.children
						}
						{
							props.viewTabs &&
							<TabContainer useRouter={'true'} 
								preserveSearchParams={true} 
								selectedTab={props.match.params.tab} 
								baseUrl={props.path || helpers.routerUrls['sagnir_aevintyri']}>

								<div tabname="listi" 
									tabtitle={props.form && props.form == FORM_LEGEND ? l('Sagnir') : props.form && props.form == FORM_FAIRYTALE ? l('Ævintýri') : l('Sagnir og ævintýri')}>
									<ListHeader resultCount={resultCount} />
									{
										table
									}
								</div>

								{
									(!props.form || props.form != FORM_FAIRYTALE) &&
									<SagnirMap tabname="kort" 
										tabtitle={l('Sögustaðir')} 
										searchParams={props.searchParams}
										setView={informantsMapView}
										onMoveEnd={(event) => setInformantsMapView(event)} />
								}
								<SagnirMap tabname="heimili" 
									tabtitle={l('Heimili heimildarmanna')} 
									informantsMap={true} 
									searchParams={props.searchParams}
									extraParams={props.form && props.form == FORM_FAIRYTALE ? 'folklore_type='+FORM_FAIRYTALE : ''}
									setView={informantsMapView}
									onMoveEnd={(event) => setInformantsMapView(event)} />

							</TabContainer>
						}
						{
							!props.viewTabs &&
							<React.Fragment>
								<ListHeader resultCount={resultCount} />
								{table}
							</React.Fragment>
						}

					</React.Fragment>
				}
				{
					data && data.length == 0 && !loading &&
					<NoResults searchTerm={currentSearchTerm} />
				}
			</div>
		</React.Fragment>
	)
}

export default SagnirList;
